import { Box, Typography } from "@mui/material";
import { DoneAll, Payments, Sync } from "@mui/icons-material";
import type { PaymentType } from "../types/payment";

type TypeMeta = {
  label: string;
  color: string;
  bgColor: string;
  IconComponent: React.ElementType;
};

const TYPE_META: Record<PaymentType, TypeMeta> = {
  RUNNING: {
    label: "Running",
    color: "#673AB7",
    bgColor: "#EDE7F6",
    IconComponent: Sync,
  },
  FINAL: {
    label: "Final",
    color: "#673AB7",
    bgColor: "#EDE7F6",
    IconComponent: DoneAll,
  },
  ADVANCE: {
    label: "Advance",
    color: "#2E7D32",
    bgColor: "#E8F5E9",
    IconComponent: Payments,
  },
};

interface PaymentTypeBadgeProps {
  type: PaymentType;
}

export default function PaymentTypeBadge({ type }: PaymentTypeBadgeProps) {
  const { label, color, bgColor, IconComponent } = TYPE_META[type] ?? {
    label: type,
    color: "#757575",
    bgColor: "#F5F5F5",
    IconComponent: Payments,
  };

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        pl: "6px",
        pr: "10px",
        py: "4px",
        borderRadius: "100px",
        color,
        backgroundColor: bgColor,
        whiteSpace: "nowrap",
      }}
    >
      <IconComponent sx={{ fontSize: 12 }} />
      <Typography
        component="span"
        sx={{
          color: "inherit",
          fontSize: "11px",
          fontWeight: 500,
          lineHeight: "14px",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
